import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { SolicitudAtestFitoService } from './datosbasicosAtestFito.service';
import { ParametrosNuevaSolicitudAtestFitoViewModel, SolicitudAtestFitoViewModel } from './datosbasicosAtestFito.types';
import { EnumIdsTcEstadoSolicitudAtestFito } from '../types/enum';
import { Tc } from '../../../core/_infrastructure/types/common';
import { EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';
import { CustomValidator } from '../../../core/_infrastructure/classes/customValidator';
import { SolicitudExViewModel } from '../../solicitudes/datosbasicos/datosbasicosEx.types';
import { SolicitudCpeViewModel } from '../../cpe/datosbasicos/cpe.types';

@Component({
    selector: 'app-solicitudatestfito-edit',
    templateUrl: './solicitudAtestFito-edit.component.html',
})
/** solicitudAtestFito-edit component*/
export class SolicitudAtestFitoEditComponent extends ComponentBase implements OnInit {
    /** solicitudAtestFito-edit ctor */

    editMode = false;
    editTitle = 'Nueva';

    habilitarGuardar = true;
    habilitarEdicion = true;

    solicitudAtestFito: SolicitudAtestFitoViewModel;
    listComunidad: Tc[];
    listProvincia: Tc[];
    listPais: Tc[];
    IdComunidad: number | null;
    IdProvincia: number | null;
    IdPaisDestino: number | null;
    IdAgenteControl: number | null;
    IdTipoSolicitudAtestFito: number;
    codigoTipoSolicitud: string;
    tituloTipoSolicitudAtestFito: string;
    tituloEstadoSolicitudAtestFito: string;
    refAtestFito: string;

    visibilitySpinnerGuardar = false;
    paramsNuevaSolicitudAtestFito: ParametrosNuevaSolicitudAtestFitoViewModel | null;

    public isCollapsedCabecera = false;
    public isCollapsedSolicitante = false;
    public isCollapsedExportador = false;
    public isCollapsedDatosEnvio = false;
    public isCollapsedTerminosCondiciones = false;

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,

        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private navMenuService: NavMenuService,
        private solicitudAtestFitoService: SolicitudAtestFitoService,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.solicitudAtestFito = new SolicitudAtestFitoViewModel();
    }

    ngOnInit() {
        this.globalService.getComunidadesAutonomas().subscribe(res => {
            this.listComunidad = res;
        });
        this.globalService.getProvincias().subscribe(res => {
            this.listProvincia = res;
        });
        this.globalService.getAllPaisesExpor().subscribe(res => {
            this.listPais = res;
        });

        this.paramsNuevaSolicitudAtestFito = new ParametrosNuevaSolicitudAtestFitoViewModel();
        this.paramsNuevaSolicitudAtestFito = this.solicitudAtestFitoService.getParamsSolicitudAtestFito();

        this.createForm();

        let id = +this.activatedRoute.snapshot.params['id'];

        //EDIT
        if (id) {
            this.editMode = true;
            this.editTitle = 'Editar';

            this.solicitudAtestFitoService.getSolicitudAtestFito(id).subscribe(result => {
                //si 'currentSolicitudExportacion' tiene valor, lo limpio, para que tome los valores de los permisos de Atestaciones ('currentSolicitudAtestacion')
                if (this.navMenuService.currentSolicitudExportacion) {
                    this.navMenuService.currentSolicitudExportacion = new SolicitudExViewModel();
                }
                if (this.navMenuService.currentSolicitudCpe) {
                    this.navMenuService.currentSolicitudCpe = new SolicitudCpeViewModel();
                }

                this.navMenuService.currentSolicitudAtestacion = result;

                this.solicitudAtestFito = result;
                this.solicitudAtestFitoService.currentIdSolicitudAtestFito = this.solicitudAtestFito.Id;

                this.IdTipoSolicitudAtestFito = this.solicitudAtestFito.TcTipoSolicitudAtestFito.Id;
                this.tituloTipoSolicitudAtestFito = this.solicitudAtestFito.TcTipoSolicitudAtestFito.Descripcion;
                this.codigoTipoSolicitud = this.solicitudAtestFito.TcTipoSolicitudAtestFito.Codigo;
                this.tituloEstadoSolicitudAtestFito = this.solicitudAtestFito.TcEstadosSolicitudAtestFito.Descripcion;

                if (this.solicitudAtestFito.TClaveSolicitudAtestFito != null) {
                    this.refAtestFito = this.solicitudAtestFito.TClaveSolicitudAtestFito.RefAtestFito;
                }

                this.updateForm();

                this.habilitarGuardar = this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.GUARDAR_SOLICITUD_ATESTACION,
                    this.solicitudAtestFito.IdEstado,
                ).Visible;
                this.habilitarEdicion = this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.MENU_DATOS_BASICOS_ATESTACION,
                    this.solicitudAtestFito.IdEstado,
                ).Editable;

                if (!this.habilitarEdicion) {
                    //metodo para deshabilitar los controles
                    this.DisableControlsConsulta();
                }
            });
        }
        //ALTA
        else {
            this.codigoTipoSolicitud = this.paramsNuevaSolicitudAtestFito!.tipoSolicitudAtestFito;
            switch (this.codigoTipoSolicitud) {
                case 'CA':
                    this.tituloTipoSolicitudAtestFito = 'Comunidad Autónoma';
                    break;
                case 'AC':
                    this.tituloTipoSolicitudAtestFito = 'Agente de Control';
                    break;

                default:
            }

            this.tituloEstadoSolicitudAtestFito = 'Borrador';

            this.habilitarGuardar = this.loggedInUser!.getAction(
                EnumCodigosTwTcAcciones.GUARDAR_SOLICITUD_ATESTACION,
                EnumIdsTcEstadoSolicitudAtestFito.ID_BORRADOR,
            ).Visible;

            this.IdComunidad = this.paramsNuevaSolicitudAtestFito!.IdCa;
            this.IdProvincia = this.paramsNuevaSolicitudAtestFito!.IdProvincia;
            this.IdPaisDestino = this.paramsNuevaSolicitudAtestFito!.IdPaisDestino;
            this.IdAgenteControl = this.paramsNuevaSolicitudAtestFito!.IdAc;
        }

        this.form.controls['IdComunidadAutonoma'].disable();
        this.form.controls['IdPaisDestino'].disable();
        this.form.controls['IdProvincia'].disable();
    }

    private DisableControlsConsulta() {
        this.form.controls['RefSolicitante'].disable();
        this.form.controls['FechaInspeccion'].disable();

        this.form.controls['NifExportador'].disable();
        this.form.controls['NombreExportador'].disable();
        this.form.controls['CiudadExportador'].disable();
        this.form.controls['IdPaisExportador'].disable();
        this.form.controls['DireccionExportador'].disable();
        this.form.controls['CodigoPostalExportador'].disable();

        this.form.controls['DeclaracionResponsable'].disable();
        this.form.controls['CheckLicencia'].disable();
        this.form.controls['CheckNormativa'].disable();
    }

    createForm() {
        this.form = this.fb.group({
            RefSolicitante: '',
            IdComunidadAutonoma: this.paramsNuevaSolicitudAtestFito != null ? this.paramsNuevaSolicitudAtestFito!.IdCa : null,
            IdProvincia: this.paramsNuevaSolicitudAtestFito != null ? this.paramsNuevaSolicitudAtestFito!.IdProvincia : null,
            IdPaisDestino: this.paramsNuevaSolicitudAtestFito != null ? this.paramsNuevaSolicitudAtestFito!.IdPaisDestino : null,
            IdUsuarioAgenteControl: this.paramsNuevaSolicitudAtestFito != null ? this.paramsNuevaSolicitudAtestFito!.IdAc : null,

            NifExportador: ['', Validators.compose([Validators.required, CustomValidator.NIFValidator])],
            NombreExportador: ['', Validators.required],
            CiudadExportador: ['', Validators.required],
            IdPaisExportador: [null, Validators.required],
            DireccionExportador: '',
            CodigoPostalExportador: ['', Validators.required],

            FechaEnvio: null,
            RefAtestFito: '',
            Pin: '',
            FechaInspeccion: [null, Validators.required],
            IdTipoSolicitudAtestFito: this.paramsNuevaSolicitudAtestFito != null ? this.paramsNuevaSolicitudAtestFito!.IdTipoSolicitudAtestFito : null,
            IdEstadoSolicitudAtestFito: EnumIdsTcEstadoSolicitudAtestFito.ID_BORRADOR, //por defecto

            DeclaracionResponsable: [false, Validators.requiredTrue],
            CheckLicencia: false,
            CheckNormativa: false,
        });
    }

    updateForm() {
        this.form.setValue({
            RefSolicitante: this.solicitudAtestFito.RefSolicitante,
            IdComunidadAutonoma: this.solicitudAtestFito.IdComunidadAutonoma,
            IdProvincia: this.solicitudAtestFito.IdProvincia,
            IdPaisDestino: this.solicitudAtestFito.IdPaisDestino,
            IdUsuarioAgenteControl: this.solicitudAtestFito.IdUsuarioAgenteControl,

            NifExportador: this.solicitudAtestFito.TExportadorSolicitudAtestFito.NifExportador,
            NombreExportador: this.solicitudAtestFito.TExportadorSolicitudAtestFito.NombreExportador,
            CiudadExportador: this.solicitudAtestFito.TExportadorSolicitudAtestFito.CiudadExportador,
            IdPaisExportador: this.solicitudAtestFito.TExportadorSolicitudAtestFito.IdPaisExportador,
            DireccionExportador: this.solicitudAtestFito.TExportadorSolicitudAtestFito.DireccionExportador,
            CodigoPostalExportador: this.solicitudAtestFito.TExportadorSolicitudAtestFito.CodigoPostalExportador,
            //FechaEnvio: null,
            FechaEnvio: this.datepipe.transform(this.solicitudAtestFito.FechaEnvio, 'dd/MM/yyyy'),
            RefAtestFito: this.solicitudAtestFito.TClaveSolicitudAtestFito != null ? this.solicitudAtestFito.TClaveSolicitudAtestFito.RefAtestFito : '',
            Pin: this.solicitudAtestFito.TClaveSolicitudAtestFito != null ? this.solicitudAtestFito.TClaveSolicitudAtestFito.Pin : '',
            FechaInspeccion: this.solicitudAtestFito.FechaInspeccion != null ? new Date(this.solicitudAtestFito.FechaInspeccion) : null,
            IdTipoSolicitudAtestFito: this.solicitudAtestFito.IdTipoSolicitudInfCa,
            IdEstadoSolicitudAtestFito: this.solicitudAtestFito.IdEstado,

            DeclaracionResponsable: this.solicitudAtestFito.DeclaracionResponsable,
            CheckLicencia: this.solicitudAtestFito.CheckLicencia,
            CheckNormativa: this.solicitudAtestFito.CheckNormativa,
        });

        this.IdComunidad = this.solicitudAtestFito.IdComunidadAutonoma;
        this.IdProvincia = this.solicitudAtestFito.IdProvincia;
        this.IdPaisDestino = this.solicitudAtestFito.IdPaisDestino;
        this.IdAgenteControl = this.solicitudAtestFito.IdUsuarioAgenteControl;
    }

    onBack() {
        this.router.navigate(['/exportacion/atestaciones']);
    }

    saveSolicitud() {
        this.visibilitySpinnerGuardar = true;
        this.onSubmit();
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos de la solicitud');

            this.isCollapsedCabecera = false;
            this.isCollapsedExportador = false;
            this.isCollapsedDatosEnvio = false;
            this.isCollapsedSolicitante = false;
            this.isCollapsedTerminosCondiciones = false;

            this.visibilitySpinnerGuardar = false;

            return;
        }

        let solicitudAtestFito = new SolicitudAtestFitoViewModel();

        solicitudAtestFito.IdTipoSolicitudInfCa = this.form.value.IdTipoSolicitudAtestFito;
        solicitudAtestFito.IdEstado = this.form.value.IdEstadoSolicitudAtestFito;
        solicitudAtestFito.IdComunidadAutonoma = this.IdComunidad!;
        solicitudAtestFito.IdProvincia = this.IdProvincia;
        solicitudAtestFito.IdPaisDestino = this.IdPaisDestino!;
        solicitudAtestFito.IdUsuarioAgenteControl = this.IdAgenteControl!;

        solicitudAtestFito.FechaInspeccion = this.form.value.FechaInspeccion;
        solicitudAtestFito.RefSolicitante = this.form.value.RefSolicitante;
        solicitudAtestFito.DeclaracionResponsable = this.form.value.DeclaracionResponsable;
        solicitudAtestFito.CheckLicencia = this.form.value.CheckLicencia;
        solicitudAtestFito.CheckNormativa = this.form.value.CheckNormativa;

        solicitudAtestFito.TExportadorSolicitudAtestFito.NifExportador = this.form.value.NifExportador;
        solicitudAtestFito.TExportadorSolicitudAtestFito.NombreExportador = this.form.value.NombreExportador;
        solicitudAtestFito.TExportadorSolicitudAtestFito.IdPaisExportador = this.form.value.IdPaisExportador;
        solicitudAtestFito.TExportadorSolicitudAtestFito.CiudadExportador = this.form.value.CiudadExportador;
        solicitudAtestFito.TExportadorSolicitudAtestFito.CodigoPostalExportador = this.form.value.CodigoPostalExportador;
        solicitudAtestFito.TExportadorSolicitudAtestFito.DireccionExportador = this.form.value.DireccionExportador;

        if (this.solicitudAtestFito.FechaCreacion != null) {
            solicitudAtestFito.FechaCreacion = this.solicitudAtestFito.FechaCreacion;
        }

        solicitudAtestFito.IdUsuarioSolicitante = this.loggedInUser!.Id; //usuario logado
        solicitudAtestFito.SinProductos = false;

        solicitudAtestFito.Id = this.solicitudAtestFito.Id;

        if (this.editMode) {
            this.solicitudAtestFitoService.editSolicitud(solicitudAtestFito).subscribe({
                next: res => {
                    this.visibilitySpinnerGuardar = false;
                    this.addSuccessMessage('Solicitud modificada correctamente');
                    this.router.navigate(['/exportacion/atestacion/datosbasicos/' + solicitudAtestFito.Id]);
                },
                error: error => {
                    this.visibilitySpinnerGuardar = false;
                    this.catchServerError(error);

                    this.isCollapsedCabecera = false;
                    this.isCollapsedExportador = false;
                    this.isCollapsedDatosEnvio = false;
                    this.isCollapsedSolicitante = false;
                    this.isCollapsedTerminosCondiciones = false;
                },
            });
        } else {
            this.solicitudAtestFitoService.createSolicitud(solicitudAtestFito).subscribe({
                next: res => {
                    this.visibilitySpinnerGuardar = false;
                    this.addSuccessMessage('Solicitud creada correctamente');
                    let idSolicitud = res;
                    this.router.navigate(['/exportacion/atestacion/datosbasicos/' + idSolicitud]);
                    //this.onBack();
                },
                error: error => {
                    this.visibilitySpinnerGuardar = false;
                    this.catchServerError(error);

                    this.isCollapsedCabecera = false;
                    this.isCollapsedExportador = false;
                    this.isCollapsedDatosEnvio = false;
                    this.isCollapsedSolicitante = false;
                    this.isCollapsedTerminosCondiciones = false;
                },
            });
        }
    }
}
